import Drawer from "pages/_components/Drawer/Drawer";
import FormattedAmount from "pages/_components/FormattedAmount";
import I18n from "pages/_components/I18n";
import Loader from "pages/_components/Loader";
import InfoTag from "pages/echeck/components/InfoTag";
import { bool, number } from "prop-types";
import Table from "rc-table";
import React, { useState } from "react";
import { cuitValidations, customValuesByTab, statusTagColor } from "util/creditBills";
import * as i18n from "util/i18n";
import { string } from "yup/lib/locale";
import Image from "pages/_components/Image";
import { useBills } from "../hooks/useBills";
import CreditBillsAccordion from "./components/CreditBillsAccordion";
import FilterForm from "./components/FilterForm";
import FilterTags from "./components/FilterTags";
import CreditBillTable from "./components/Table";

export const CreditBillTabs = ({ isDesktop, tabOption, positionTab }) => {
    const [openSidebar, setOpenSidebar] = useState(false);
    const { fetchMoreBills, summaryData, fetching } = useBills({ positionTab, tabOption });
    const customValues = customValuesByTab[tabOption];
    const filterCuits = Object.keys(customValues);

    const columns = [
        {
            title: i18n.get("creditBill.table.quantity"),
            dataIndex: "quantity",
            key: "quantity",
        },
        {
            title: i18n.get("creditBill.table.state"),
            dataIndex: "status",
            key: "status",
            render: (text) => <InfoTag type="info" message={text} tagBackground={statusTagColor(text)} />,
        },
        {
            title: i18n.get("creditBill.table.amount"),
            dataIndex: "totalAmount",
            key: "totalAmount",
            render: (text, { currency }) => <FormattedAmount currency={currency} quantity={text} />,
        },
    ];

    if (fetching) {
        return <Loader />;
    }

    return (
        <div className="container credit-bills__tabs">
            <FilterTags openSideBarFilters={() => setOpenSidebar(true)} tabOption={tabOption} />
            {summaryData.length === 0 ? (
                <div className="box info service-payments__no-data">
                    <Image src="images/information_fill.svg" /> <I18n id="fce.service.noData" />
                </div>
            ) : (
                <>
                    <CreditBillsAccordion
                        className="credit-bills__resumen box box-shadow"
                        item={<I18n id="creditBill.summary.title" component="h2" />}
                        table={
                            <Table
                                rowClassName="credit-bills__resumen-table underlined"
                                columns={columns}
                                data={summaryData}
                            />
                        }
                    />
                    <CreditBillTable isDesktop={isDesktop} fetchMoreBills={fetchMoreBills} tabOption={tabOption} />
                </>
            )}

            <Drawer openSidebar={openSidebar} toggleSidebar={setOpenSidebar}>
                <FilterForm
                    customValues={customValues}
                    closeSidebar={setOpenSidebar}
                    tabOption={tabOption}
                    customValidations={cuitValidations(...filterCuits)}
                />
            </Drawer>
        </div>
    );
};

CreditBillTabs.propTypes = {
    isDesktop: bool.isRequired,
    tabOption: string.isRequired,
    positionTab: number.isRequired,
};

export default CreditBillTabs;
